import React from 'react';
import LoadingSpiner from '../Loader/LoadingSpiner';
import classNames from 'classnames';

interface ActionButtonProps {
    text: string;
    Icon?: any;
    onClick?: () => void;
    loading?: boolean;
    className?: string;
}

export default function ActionButton(props: ActionButtonProps) {
    const { text, Icon, onClick, loading, className } = props;

    const CurrentIcon = () => loading ? <LoadingSpiner/> : <Icon/>;

    const classes = className || "btn btn-base btn-xs mr-2";
    
    return (
        <button className={classes} onClick={onClick}><CurrentIcon/>{text}</button>
    )
}